export default __webpack_public_path__ + "static/media/uofc-logo-temp-sharpened.7cf30e0d.png";